import type { LucideIcon } from 'lucide-react';
import { cn } from '@/ui/lib/utils';

interface StatusPlaceholderProps {
	icon: LucideIcon;
	title: string;
	description?: string;
	variant?: 'default' | 'error';
	action?: React.ReactNode;
}

export function StatusPlaceholder({
	icon: Icon,
	title,
	description,
	variant = 'default',
	action,
}: StatusPlaceholderProps) {
	return (
		<div className='flex flex-col items-center justify-center py-20 gap-4 text-center'>
			<div
				className={cn(
					'rounded-full p-5',
					variant === 'error' ? 'bg-destructive/10' : 'bg-muted',
				)}
			>
				<Icon
					className={cn(
						'size-10',
						variant === 'error'
							? 'text-destructive'
							: 'text-muted-foreground',
					)}
				/>
			</div>
			<div>
				<p className='font-semibold text-foreground text-base'>
					{title}
				</p>
				{description && (
					<p className='mt-1 text-sm text-muted-foreground'>
						{description}
					</p>
				)}
			</div>
			{action}
		</div>
	);
}
